import request from './request'
import useFormData from './request/plugins/useFormData'
// import setHeader from './request/plugins/setHeader'
// 更新用户资料
export function updateUserInfo(data) {
  return request('/uaa/api/renter/information', 'POST', data)
}

// 获取登录验证码
export function getCode(data) {
  return request('/uaa/api/public/sendAuthorizeCode', 'GET', data)
}

// 绑定手机号码
export function bindMobile(data) {
  return request('uaa/api/bindPhoneNumber', 'POST', data)
}

// 基因实验室订单列表
export function getLabOrderList(data) {
  return request('/lab/api/gene/order/export', 'POST', data)
}
// 基因实验室订单列表（过滤掉有待办的订单）
export function excludeTask(data) {
  return request('/lab/api/gene/order/exclude-task', 'POST', data)
}

// 基因实验室订单详情
export function getLabOrder(id) {
  return request('/lab/api/gene/order/' + id)
}
// 基因实验室订单状态详情
export function getLabOrderStatusDetail(data) {
  return request('/lab/api/gene/order/status/detail/by-example', 'POST', data)
}

export function getOrderIsProcess(data) {
  return request('/lab/api/orders/is-process', 'POST', data)
}
/**
 * 基因实验室订单状态更新（不上传数据质控文件）
 * @param {*} data
 */
export function geneOrderStatusUpdateWithoutAttachment(data) {
  return request('/lab/api/workflow/order-batch-status-update/without-attachment', 'POST', data)
}
/**
 * 订单状态更新文件上传接口
 * @param {*} data
 */
export function uploadTempFile(data) {
  return useFormData(request)('/lab/api/workflow/upload-temp-file', 'multipleFILE', data)
}
/**
 * 获取基因实验室订单列表数据
 * @param {*} page
 * @param {*} size
 */
export function getGeneLabOrders(data) {
  data.pageable = { page: 0, size: 9999 }
  return request('/lab/api/gene/order/by-example', 'POST', data)
}
/**
 * 获取目标状态的所有订单
 * @param {*} data
 */
export function getGeneLabOrdersTargetStatus(data) {
  // let data ={}
  // data.example={batchNumber:batchNumber}
  data.pageable = { page: 0, size: 9999 }
    // data.targetStatus = targetStatus
  return request('/lab/api/gene/order/by-example/target-status', 'POST', data)
}
/**
 * 订单处理列表
 * @param {*} data
 */
export function orderHandleList(data) {
  return request('/lab/api/future-order-action-tasks/by-example', 'POST', data)
}
/**
 * 基因实验室订单状态更新(样本提取批量手动勾选专用接口)
 * @param {*} data
 */
export function geneOrderStatusUpdateNoFile(data) {
  return request('/lab/api/workflow/order-batch-status-update/without-attachment', 'POST', data)
}
/**
 * oss直传获取签名
 * @param {*} data
 */
export function ossUploadBigFile(data) {
  return request('/lab/api/data-transfer/raw-data-upload-policy', 'POST', data)
}
/**
 * 根据签名上传文件(即将废弃)
 * @param {*} data
 */
export function getSignature(url, data) {
  return request(url, 'multipleFILE', data)
}

/**
 * 根据签名上传文件(useFormData)
 * @param {*} data
 */
export function getOssSignature(url, data) {
  return useFormData(request)(url, 'multipleFILE', data)
}

/**
 * 订单数的统计接口返回异常订单数和代办数
 * oss直传获取签名
 * @param {*} data
 */
export function getSpecialOrderCountPlate(data) {
  return request('/lab/api/order/count', 'POST', data)
}
export function getSpecialOrderCount() {
  return request('/lab/api/order/count', 'GET')
}
// 新建/编辑/提交商品
export function createdGoodsDraft(data) {
  return request('/mall/api/goods/save', 'POST', data)
}
// 根据商品归属查询商品类型列表
export function getGoodsTypeList(data) {
  return request('/mall/api/goods-type/belong/' + data.belong, 'GET')
}
// 获取全部商品类型
export function getGoodsTypes() {
  return request('/mall/api/goods-type', 'GET')
}
// 商品列表
export function goodsList(data) {
  return request('/mall/api/goods', 'POST', data)
}
// 促销活动相关商品列表
export function salesGoodsList(data) {
  return request('/mallsales/api/goods', 'POST', data)
}
// 商品详情
export function goodsDetail(id) {
  return request('/mall/api/goods/' + id, 'GET')
}
// 促销活动商品详情
export function salesGoodsDetail(id) {
  return request('/mallsales/api/goods/' + id, 'GET')
}
// 删除商品
export function goodsDelete(id) {
  return request('/mall/api/goods/' + id, 'DELETE')
}
/**
 * 处理代办
 * @param {*} data
 */
export function pendingTasksSubmit(data) {
  return request('/lab/api/future-order-action-tasks/submit', 'POST', data)
}
// 商品推荐
export function goodsRecommend(id) {
  return request('/mall/api/goods/recommend/' + id, 'POST')
}
// 取消推荐
export function goodsRecommendCancel(id) {
  return request('/mall/api/goods/cancel-recommend/' + id, 'POST')
}
// 修改推荐值
export function updateRanking(data) {
  return request('/mall/api/goods/update-ranking', 'PUT', data)
}
// 商品审核通过
export function goodsPublish(data) {
  return request('/mall/api/goods/publish', 'POST', data)
}
// 商品提交审核
export function applyForApproval(id) {
  return request('/mall/api/goods/apply-for-approval/' + id, 'POST')
}
// 商品审核驳回
export function approvalReject(id) {
  return request('/mall/api/goods/approval-reject/' + id, 'POST')
}
// 获取分组列表
export function getGoodsGroup(data) {
  return request('/mall/api/goods-groups/by-example', 'POST', data)
}
// 商品下架
export function goodsOffShelves(id) {
  return request('/mall/api/goods/offShelves/' + id, 'POST')
}
export function newGoodsGroup(data) {
  return request('/mall/api/goods-groups', 'POST', data)
}
export function goodsGroupDetail(id) {
  return request('/mall/api/goods-groups/' + id, 'GET')
}
// 编辑商品分组
export function groupEdit(data) {
  return request('/mall/api/goods-groups', 'PUT', data)
}
// 删除商品分组
export function groupDelete(id) {
  return request('/mall/api/goods-groups/' + id, 'DELETE')
}
// 基因实验室检测平台列表
export function labTestPlatformList(data) {
  return request('/lab/api/gene/product/lab-method', 'POST', data)
}
/**
 * 检测列表-根据类型进行筛选/搜索检测项
 * @param {*} id
 */
export function getDetectionListByFilter(data) {
  return request('/gene/api/detection-item-entities/query', 'GET', data)
}
/**
 * 新建--检测项
 * @param {*} form
 */
export function detectionAdd(form) {
  return request('/gene/api/detection-item-entities', 'POST', form)
}
/**
 * 获取检测项
 *
 */
export function getDetection(id) {
  return request('/gene/api/detection-item-entities/' + id)
}
/**
 * 检测项 - 更新
 * @param {*} id
 * @param {*} form
 */
export function updateDetection(form) {
  return request('/gene/api/detection-item-entities', 'PUT', form)
}
/**
 * 删除检测项
 *
 */
export function deleteDetection(id) {
  return request('/gene/api/detection-item-entities/' + id, 'DELETE')
}

/**
 * 获取检测项语料列表数据
 * @param {*} page
 * @param {*} size
 */
export function getDetectionCorpusList(data) {
  return request('/gene/api/detection-item-corpus-entities/query', 'GET', data)
}
/**
 * 获取检测项语料
 *
 */
export function getDetectionCorpus(id) {
  return request('/gene/api/detection-item-corpus-entities/' + id)
}
/**
 * 新建--检测项语料
 * @param {*} form
 */
export function detectionCorpusAdd(form) {
  return request('/gene/api/detection-item-corpus-entities', 'POST', form)
}

// 创建检测方法
export function methodAdd(data) {
  return request('/lab/api/gene/manager/method', 'POST', data)
}
// 修改检测方法
export function methodUpdate(data) {
  return request('/lab/api/gene/manager/method', 'PUT', data)
}

/**
 * 删除检测方法
 *
 */
export function methodDelete(id) {
  return request('/lab/api/gene/manager/method/?method_id=' + id, 'DELETE')
}
export function getDetectionPackageEntities(data) {
  return request('/gene/api/detection-package-entities', 'GET', data)
}
/**
 * 根据检测项id查询检测项语料
 * @param {*} data
 */
export function getDetectionCorpusByid(id) {
  return request('/gene/api/detection-item-corpus-entities/find-detectionItemId/' + id, 'POST')
}
/**
 * 获取检测项配置
 *
 */
export function getDetectionConfig(id) {
  return request('/gene/api/detection-item-config-entities/by-detection-item/' + id)
}
/**
 * 获取基因套餐列表
 *
 */
export function getDetectionPackageList(data) {
  return request('/gene/api/detection-package-entities/query', 'GET', data)
}
// 根据查询条件获取套餐列表
export function getPackageList(data) {
  return request('/gene/api/detection-package-entities/by-example', 'POST', data)
}
/**
 * 删除套餐
 *
 */
export function deleteDetectionPackage(id) {
  return request('/gene/api/detection-package-entities/' + id, 'DELETE')
}
/**
 * 导入检测项配置参数
 * @param {*} form
 */
export function importConfigParams(form) {
  return request('/gene/api/importing/config-params', 'multipleFILE', form)
}
/**
 * 获取套餐全部数据
 *
 */
export function getDetectionPackage(id) {
  return request('/gene/api/detection-package-entities/full/' + id, 'GET')
}
/**
 * 新建--套餐
 * @param {*} form
 */
export function detectionPackageAdd(form) {
  return request('/gene/api/detection-package-entities', 'POST', form)
}
// 获取商城订单列表
export function getMallOrders(data) {
  return request('/mallsales/api/mall-orders/by-example', 'POST', data)
}
// 获取商城列表接口（按条件查询）
export function getMallOrderOfAll(data) {
  return request('/mallsales/api/mall-orders/page-query-for-all-orders', 'POST', data)
}
// 获取商品订单详情
export function goodsOrderDetail(id) {
  return request('/mallsales/api/mall-orders/' + id, 'GET')
}
// 根据订单id获取发票列表
export function getOrderInvoice(id) {
  return request('/mallsales/api/mall-orders/invoice/' + id, 'GET')
}
// 下载发票
export function downloadInvoice(id) {
  return request('/mallsales/api/invoice/' + id, 'GET')
}
// 获取指定收货地址
export function shippingAddress(id) {
  return request('/mallsales/api/shipping-addresses/' + id, 'GET')
}
// 创建发货信息
export function creatDeliverGoodsDetail(data) {
  return request('/mallsales/api/mall-orders/ship', 'POST', data)
}
// 退款审批通过
export function approvalRefundment(data) {
  return request('/mallsales/api/mall-orders/approval-refundment', 'POST', data)
}
/**
 * 检测项语料 - 更新
 * @param {*} id
 * @param {*} form
 */
export function updateDetectionCorpus(form) {
  return request('/gene/api/detection-item-corpus-entities', 'PUT', form)
}
// 运营管理员申请退款
export function applyForRefundment(data) {
  return request('/mallsales/api/mall-orders/apply-for-refundment', 'POST', data)
}
/**
 * 删除检测项语料
 *
 */
export function deleteDetectionCorpus(id) {
  return request('/gene/api/detection-item-corpus-entities/' + id, 'DELETE')
}
/**
 * 创建知识库结构
 *
 */
export function createCorpusStructure(data) {
  return request('/gene/api/corpus-structures', 'POST', data)
}
/**
 * 获取知识库结构列表
 *
 */
export function getCorpusStructureList(data) {
  return request('/gene/api/corpus-structures', 'GET', data)
}
/**
 * 更新知识库结构
 *
 */
export function updateCorpusStructure(data) {
  return request('/gene/api/corpus-structures', 'PUT', data)
}
/**
 * 删除知识库结构
 *
 */
export function deleteCorpusStructure(id) {
  return request('/gene/api/corpus-structures/' + id, 'DELETE')
}
/**
 * 创建标题图标
 *
 */
export function createCorpusHeaderImages(data) {
  return request('/gene/api/corpus-header-images', 'POST', data)
}
/**
 * 删除知识库结构
 *
 */
export function getCorpusStructure(id) {
  return request('/gene/api/corpus-structures/' + id, 'GET')
}
/**
 * 搜索检测项
 *
 */
export function searchDetectionItem(key) {
  return request('/gene/api/detection-item-search?searchKey=' + key, 'GET')
}
/**
 * 获取知识库结构列表
 *
 */
export function getCorpusStructureListByType(data) {
  return request('/gene/api/corpus-structures/query-type', 'GET', data)
}
// 克根据姓名模糊查询
export function getCustomerSamples(data) {
  return request('/gene/api/customers/query', 'GET', data)
}
// 获取左侧菜单
export function getMenu() {
  return request('/uaa/api/user/menus', 'GET')
}
export function updateDetectionPackage(form) {
  return request('/gene/api/detection-package-entities', 'PUT', form)
}

/**
 * 获取报告
 * @param {*} form
 */
export function getReportData(data) {
  return request('/gene/api/report/data?jobId=' + data.jobId + '&strictCorpusCheck=true', 'POST', {})
}
/**
 * 删除检测项配置
 *
 */
export function deleteDetectionConfig(id) {
  return request('/gene/api/detection-item-config-entities/' + id, 'DELETE')
}
/**
 * 获取配置库列表
 *
 */
export function geConfigSuiteNames(params) {
  return request('/gene/api/config-suite-names', 'GET', params)
}
// /**
//  * 根据签名上传文件
//  * @param {*} data
//  */
// export function test (url, data) {
//   return useFormData(setHeader(request, { 'Content-Type': 'multipart/form-data' }))(url, 'POST', data)
//   // return useFormData(request)(url, 'multipleFILE', data)
// }
export function generalUpload(data) {
  return request('/messages/api/upload', 'multipleFILE', data)
}
// 退款订单分页查询
export function refundmentOrders(data) {
  return request('/mallsales/api/mall-orders/page-query-for-refundment-orders', 'POST', data)
}
// 销售订单详情，状态获取
export function getOrderProgress(id) {
  return request('/mallsales/api/mall-orders/get-order-progress/' + id, 'GET')
}
// 导出退款订单列表Excel
export function exportForRefundment(data) {
  //   return exportBinary('/mallsales/api/mall-orders/export-for-refundment-orders', 'POST', data)
  return request('/mallsales/api/mall-orders/export-for-refundment-orders', 'POST', data)
}
// 导出全部订单列表excel
export function exportAllOrder(data) {
  //   return exportBinary('/mallsales/api/mall-orders/export-for-all-orders', 'POST', data)
  return request('/mallsales/api/mall-orders/export-for-all-orders', 'POST', data)
}
// 带重采订单导出
export function exportResampleOrder(data) {
  return exportBinary('/mallsales/api/mall-orders/export-resample-waiting-for-processing', 'POST', data)
}
// 导出咨询工单
export function exportConsulting(data) {
  return exportBinary('/mallsales/api/consultings/download', 'POST', data)
}
// 下载并导出二进制文件
export function exportBinary(url, method, data) {
  return request(url, method, data, {
    headers: {
      'content-type': 'application/json;charset=UTF-8',
      filename: 'utf-8'
    },
    responseType: 'arraybuffer'
  })
}
/**
 * 删除检测项配置
 *
 */
export function getDetectionConfigParams(data) {
  return request(`/gene/api/detection-item-config-with-params-paged/${data.id}`, 'GET', data)
}
// 根据检测项id获取到对应的语料和配置
export function getDetectionWithCorpusAndConfig(id) {
  return request('/gene/api/detection-item-with-config-and-corpus/' + id, 'GET')
}
// 获取优惠劵列表
export function getCouponsList(data) {
  return request('/mallsales/api/discount-coupons/find-by-example', 'POST', data)
}
// 优惠劵提交审核(提交之后，状态变为“未审核”)
export function createCoupons(data) {
  return request('/mallsales/api/discount-coupons/create', 'POST', data)
}
// 保存优惠劵
export function saveCoupons(data) {
  return request('/mallsales/api/discount-coupons/save', 'POST', data)
}
// 获取优惠券详情
export function couponDetail(id) {
  return request('/mallsales/api/discount-coupons/with-goods-info/' + id, 'GET')
}
// 编辑优惠劵接口
export function couponEdit(data) {
  return request('/mallsales/api/discount-coupons/update', 'POST', data)
}
// 删除优惠劵
export function coupontDelete(id) {
  return request('/mallsales/api/discount-coupons/' + id, 'DELETE')
}
// 更改优惠劵状态
export function couponUpdateStatus(data) {
  return request('/mallsales/api/discount-coupons/update/status', 'POST', data)
}
// 下载/访问私有资源
export function downloadPrivateResource(data) {
  // Agena不部署messages服务, 所以使用lab的resource
  return request('/lab/api/private-resource/get-url', 'GET', data)
    // return request('/messages/api/private-resource/get-url', 'GET', data)
}
// 创建优惠劵活动
export function createPromotion(data) {
  return request('/mallsales/api/promotion-events/create/' + data.type, 'POST', data)
}
// 查询促销活动列表
export function getPromotionList(data) {
  return request('/mallsales/api/promotion-events/find-by-example', 'POST', data)
}
// 获取促销活动详情
export function promotionDetail(id) {
  return request('/mallsales/api/promotion-events/detail-info/' + id, 'POST')
}
// 删除促销活动
export function promotionDelete(id) {
  return request('/mallsales/api/promotion-events/' + id, 'DELETE')
}
// 更改促销活动状态
export function promotionStatus(data) {
  return request('/mallsales/api/promotion-events/update/status', 'POST', data)
}
// 编辑促销活动
export function promotionEdit(data) {
  return request('mallsales/api/promotion-events/update/' + data.type, 'POST', data)
}
// 管理员关闭订单
export function closeOrder(id) {
  return request('/mallsales/api/mall-orders/close-order/' + id, 'GET')
}
// 获取售后信息列表
export function afterSalesPolicies(data) {
  return request('/mall/api/after-sales-policies', 'GET', data)
}
// 获取售后政策详情
export function afterSalesPolicyDetail(id) {
  return request('/mall/api/after-sales-policies/' + id, 'GET')
}
// 删除售后政策
export function afterSalesDelete(id) {
  return request('/mall/api/after-sales-policies/' + id, 'DELETE')
}
// 获取运费规则列表
export function getCarriagePolicies(data) {
  return request('/mall/api/carriage-policies', 'GET', data)
}
// 获取运费规则详情
export function carriagePoliciesDetail(id) {
  return request('/mall/api/carriage-policies/' + id, 'GET')
}
// 新建运费规则
export function creatCarriagePolicies(data) {
  return request('/mall/api/carriage-policies', 'POST', data)
}
// 获取隐私条款列表
export function getPrivacyPolicies(data) {
  return request('/mall/api/privacy-policies', 'GET', data)
}
// 删除运费规则
export function carriagePolicyDelete(id) {
  return request('/mall/api/carriage-policies/' + id, 'DELETE')
}
// 新建隐私条款
export function createPrivacyPolicies(data) {
  return request('/mall/api/privacy-policies', 'POST', data)
}
// 获取隐私条款详情
export function privacyPolicyDetail(id) {
  return request('/mall/api/privacy-policies/' + id, 'GET')
}
export function privacyPolicyDelete(id) {
  return request('/mall/api/privacy-policies/' + id, 'DELETE')
}
// 根据基因检测套餐的平台查询检测周期
export function technologyCycle(type) {
  return request('/mallsales/api/lab/product/find-by-sequencing-technology/' + type, 'GET')
}
// 新建售后政策
export function creatAfterSalesPolicies(data) {
  return request('/mall/api/after-sales-policies', 'POST', data)
}
// 编辑售后政策
export function editAfterSalesPolicy(data) {
  return request('/mall/api/after-sales-policies', 'PUT', data)
}
// 商城用户查询
export function getMallUser(data) {
  return request('/uaa/api/mall-user/page-by-query', 'POST', data)
}
// 后台商品分组，商品列表排序接口
export function goodsSort(data) {
  return request('/mall/api/goods/advanced-query-for-list', 'POST', data)
}
// 后台商品分组，商品列表排序接口,带sales信息
export function salesGoodsSort(data) {
  return request('/mallsales/api/goods/advanced-query-for-list', 'POST', data)
}
// 广告位列表接口
export function getBannerList(data) {
  return request('/mall/api/promotion-banners', 'GET', data)
}
// 获取所有的广告位定义
export function bannersPositions(data) {
  return request('/mall/api/promotion-banners/positions', 'GET', data)
}
// 替换指定位置上的所有推荐
export function bannersReplace(data) {
  return request('/mall/api/promotion-banners/replace', 'POST', data)
}
// 根据条件查询推荐位列表
export function bannerByExample(data) {
  return request('/mall/api/promotion-banners/by-example', 'POST', data)
}
// 查询活动设置接口
export function getActiveSetList(data) {
  return request('/mall/api/promotion-banners/by-example-with-position', 'POST', data)
}
// 根据指定的商品唯一id（goodsRecordId），获取其广告位资源
export function bannerGoodsResources(data) {
  return request('/mall/api/promotion-banners/' + data.type + '/goods/' + data.id, 'GET')
}
// 根据指定的新闻id,获取其广告位资源
export function bannerNewsResouces(data) {
  return request('/mall/api/promotion-banners/' + data.type + '/news/' + data.id, 'GET')
}
// 活动设置，根据所选优惠活动，获取url信息
export function promotionBannerUrl(data) {
  return request('/mallsales/api/promotion-events/banner-url/' + data.promotionEventId, 'GET', data)
}
// 根据检测项名字进行查询，用于查重
export function getDetectionItemByName(name) {
  let data = { name: name }
  return request(`gene/api/detection-item-entities/find`, 'GET', data)
}
// 根据知识库名称和知识库名进行查询，用于查重
export function getDetectionCorpusBycorpusAndName(corpusName, name) {
  let data = { corpusName: corpusName, name: name }
  return request(`gene/api/detection-item-corpus-by-name-and-corpus-name`, 'GET', data)
}
// 根据知识库结构名称和类型进行查询，用于查重
export function getCorpusStructureByquery(name, type) {
  let data = { type: type, name: name }
  return request(`gene/api/corpus-structures/query-type-name`, 'GET', data)
}
// 分页查询新闻列表
export function getNewsList(data) {
  // return request('/mall/api/news/get-news-by-example', 'POST', data)
  return request('/mall/api/news/get-news-query', 'POST', data)
}
// 获取新闻分类
export function newCategories() {
  return request('/mall/api/news/categories', 'GET')
}
// 新建新闻
export function creatNews(data) {
  return request('/mall/api/news', 'POST', data)
}
// 新建并发布新闻
export function saveAndPublishNews(data) {
  return request('/mall/api/news/save-and-publish', 'POST', data)
}
// 发布新闻
export function publishNews(id) {
  return request('/mall/api/news/publish/' + id, 'POST')
}
// 新闻下架
export function disabledNews(id) {
  return request('/mall/api/news/disable/' + id, 'POST')
}
// 新闻详情
export function newsDetail(id) {
  return request('/mall/api/news/' + id, 'GET')
}
// 编辑新闻
export function editNews(data) {
  return request('/mall/api/news', 'PUT', data)
}
// 删除新闻
export function deleteNews(id) {
  return request('/mall/api/news/' + id, 'DELETE')
}
// 获取省市区列表
export function getDivision(data) {
  // 查询省级列表provinceGbCode传0，cityGbCode传0；
  // 查询市级列表provinceGbCode传父级，cityGbCode传0，
  // 查询区级列表provinceGbCode传父级，cityGbCode传父级，
  return request(
    '/messages/api/gbcode-admin-divisions/' +
    data.provinceGbCode +
    '/' +
    data.cityGbCode,
    'GET'
  )
}
// 获取指定公开资源文件的最终链接（不带重定向），可直接作为图片链接用于图片显示（download设置为false），或者在新窗口中打开作为文件下载（download设置为true）
export function getResuorceUrl(data) {
  // Agena不部署messages服务, 所以使用lab的resource
  return request('/lab/api/public/public-resource/get-url', 'GET', data)
    // return request('/messages/api/public/public-resource/get-url', 'GET', data)
}
// 文章分页查询
export function enumerationByExample(data) {
  return request('/mall/api/enumeration/' + data.type + '/by-example', 'POST', data)
}
// 新闻分类带数量统计的查询接口
export function categoriesWithNewsCount(data) {
  return request('/mall/api/news/categories-with-news-count', 'GET', data)
}
// 新建文章
export function createEnumeration(data) {
  return request('/mall/api/news/categories/create', 'POST', data)
}
// 获取新闻分类详情
export function enumerationDetial(id) {
  // return request('/mall/api/enumeration/by-id/' + id, 'GET')
  return request('/mall/api/news/categories/' + id, 'GET')
}
// 编辑新闻分类
export function editNewsCategories(data) {
  return request('/mall/api/news/categories/update', 'POST', data)
}
// 获取待重采订单
export function waitingForSampleRecollect(data) {
  return request('/mallsales/api/mall-orders/resample/get-waiting-for-processing', 'POST', data)
}
// 创建重采订单
export function creatSampleRecollect(data) {
  return request('/mallsales/api/internal-orders/resample-place', 'POST', data)
}
// 重采订单详情。通过样本条码号查询订单详情
export function sampleOrderDetail(sampleId) {
  return request('/mallsales/api/mall-samples/get-mall-order/' + sampleId, 'GET')
}
// 根据样本条码号查询重采价格
export function sampleRecollectPrice(sampleId) {
  return request('lab/api/future-order-action-tasks/order/by-sample-id/' + sampleId, 'GET')
}
// 获取快递列表
export function getExpresses(data) {
  return request('/mallsales/api/express-companies', 'GET', data)
}
// 创建快递
export function createExporess(data) {
  return request('/mallsales/api/express-companies', 'POST', data)
}
// 新建标签
export function createLabels(data) {
  return request('/recommendation/api/tags', 'POST', data)
}
// 按条件获取标签列表
export function getLabelsList(data) {
  return request('/recommendation/api/tags-by-example', 'POST', data)
}
// 关联标签，选择标签时，根据名字的模糊查询
export function labelListByName(data) {
  return request('/recommendation/api/tags-by-name-like', 'POST', data)
}
// 编辑标签
export function editLabel(data) {
  return request('/recommendation/api/tags', 'PUT', data)
}
// 删除标签
export function deleteLabel(id) {
  return request('/recommendation/api/tags/' + id, 'delete')
}
// 获取标签关联
export function getRelatedLabels(data) {
  return request('/recommendation/api/related-tags', 'GET', data)
}
// 新建关联标签
export function createRelatedLabel(data) {
  return request('/recommendation/api/related-tags', 'POST', data)
}
// 更新关联标签列表
export function updateRelatedLabel(data) {
  return request('/recommendation/api/related-tags-list', 'POST', data)
}
// 删除关联标签
export function deleteRelatedLabel(id) {
  return request('/recommendation/api/related-tags/' + id, 'DELETE')
}
// 第三方供应商列表
export function getVendorsOrganizations(data) {
  data = data.pageable ? data : { pageable: data }
  return request('/mallsales/api/vendors/page', 'POST', data)
}
// 新建退款原因
export function newRefundmentReason(data) {
  return request('/mallsales/api/enumeration/' + data.type + '/add', 'POST', data)
}
// 获取退款原因
export function getRefundmentReason(data) {
  return request('/mallsales/api/enumeration/' + data.type + '/', 'GET')
}
// 退款驳回
export function rejectRefundment(data) {
  return request('/mallsales/api/mall-orders/reject-refundment', 'POST', data)
}
// 给商品新建标签，需要给商品标签打点
export function tagsObjects(data) {
  return request('/recommendation/api/tag-objects', 'POST', data)
}
// banner位置信息详情
export function promotionBannersPosition(data) {
  return request('/mall/api/promotion-banners/' + data.type + '/position/' + data.id)
}
// 分页查询商品分组（带商品总量信息）
export function groupWithGoodsCount(data) {
  return request('/mall/api/goods-groups/find-group-with-goods-count', 'POST', data)
}
// 第三方供应商列表
export function getVendorsList(data) {
  return request('/mallsales/api/vendors/page', 'POST', data)
}
// 设置商品未置顶
export function setStick(id) {
  return request('/mall/api/goods/stick/' + id, 'POST')
}
export function cancelStick(id) {
  return request('/mall/api/goods/cancel-stick/' + id, 'POST')
}
// 修改新闻推荐值
export function updateNewsRanking(data) {
  return request('/mall/api/news/ranking/' + data.id + '/' + data.ranking, 'POST')
}
// 设置新闻未置顶
export function setNewsStick(id) {
  return request('/mall/api/news/stick/' + id, 'POST')
}
export function cancelNewsStick(id) {
  return request('/mall/api/news/cancel-stick/' + id, 'POST')
}
// 新闻推荐
export function NewsRecommend(id) {
  return request('/mall/api/news/visible/' + id, 'POST')
}
// 取消推荐
export function NewsRecommendCancel(id) {
  return request('/mall/api/news/cancel-visible/' + id, 'POST')
}
// 获取预约工单列表
export function getOrderWorkList(data) {
  return request('/mallsales/api/consultings/by-example', 'POST', data)
}
// 获取预约工单详情
export function getOrderWorkDetail(id) {
  return request('/mallsales/api/consultings/' + id, 'GET')
}
// 预约工单修改
export function OrderWorkUpdate(data) {
  return request('/mallsales/api/consultings/update', 'POST', data)
}
// 获取预约工单导出历史列表
export function getOrderWorkHistoryList(data) {
  return request('/mallsales/api/consultings/history', 'GET', data)
}
// 获取预约工单导出历史列表
export function getCommodityDetail(id) {
  return request('/mallsales/api/public/goods/' + id, 'GET')
}
// 预约工单导出历史列表下载
export function HistoryListDownload(id) {
  return request('/mallsales/api/consultings/download-history/' + id, 'GET')
}
// 获取客户列表
export function getVendors(data) {
  return request('/uaa/api/client-organizations/search', 'POST', data)
}

// 实验室订单模糊查询
export function labOrderFuzzy(data) {
  return request(`/lab/api/gene/order/fuzzy-query/`, 'POST', data)
}
// 获取指定商城用户信息
export function mallUserDetail(id) {
  return request('/uaa/api/mall-user/' + id, 'GET')
}
// 获取指定商城用户信息+收货地址
export function getUserDetailAddress(id) {
  return request('/uaa/api/mall-user/detail/' + id, 'GET')
}
// 获取第三方的职位列表
export function getPosition() {
  let data = {
    page: 0,
    size: 99999
  }
  return request(`/uaa/api/counselor/positions/`, 'GET', data)
}
// 创建第三方的职位
export function createPosition(data) {
  return request(`/uaa/api/counselor/positions/save`, 'POST', data)
}
// 获取第三方的职位列表
export function getCompany() {
  let data = {
    page: 0,
    size: 99999
  }
  return request(`/uaa/api/counselor/companies/`, 'GET', data)
}
// 创建第三方的职位
export function createCompany(data) {
  return request(`/uaa/api/counselor/companies/save`, 'POST', data)
}
export function getCounselorList(data) {
  return request(`/uaa/api/counselor-user-role-informations`, 'GET', data)
}
export function createCounselor(data) {
  return request(`/uaa/api/counselor-user-role-informations`, 'POST', data)
}
export function updateCounselor(data) {
  return request(`/uaa/api/counselor-user-role-informations`, 'PUT', data)
}
export function deleteCounselor(id) {
  return request(`/uaa/api/counselor-user-role-informations/${id}`, 'DELETE')
}
export function getCounselor(id) {
  return request(`/uaa/api/counselor-user-role-informations/${id}`, 'GET')
}
// 导出第三方供应商
export function exportVendors(data) {
  return exportBinary(`/mallsales/api/vendors/export`, 'POST', data)
}
// CPS缴费
export function cpsPaymentList(data) {
  return request('/mallsales/api/mall/order/bill/find-all', 'POST', data)
}
// CPS缴费
export function counselorFind(data) {
  return request('uaa/api/counselor-user-role-informations/advanced-query', 'POST', data)
}
// CPS缴费列表的导出
export function exportCpsPaymentList(data) {
  //   return exportBinary('/mallsales/api/mall/order/bill/down-find-all', 'POST', data)
  return request('/mallsales/api/mall/order/bill/down-find-all', 'POST', data)
}
// 根据用户id获取健康档案
export function healthRecords(data) {
  return request('/uaa/api/health-records/by-type/' + data.type, 'POST', data.data)
}
// 根据用户id获取里程碑
export function lifeMilestone(data) {
  return request('/mallsales/api/life/milestone/query', 'POST', data)
}
// 根据用户id获取里程碑
export function getItemsByBaseId(data) {
  return request('/gene/api/package-detection-items/query', 'GET', data)
}
// 获取消息列表
export function getNoticeList(data) {
  return request('/messages/api/app-messages/page', 'POST', data)
}
// 搜索咨询工单列表
export function getOrderWorkSearch(data) {
  return request(`/mallsales/api/consultings/key-like`, 'GET', data)
}
// 发布消息
export function publishNotice(data) {
  return request('/messages/api/app-messages', 'POST', data)
}
// 消息详情
export function noticeDetail(id) {
  return request('/messages/api/app-messages/' + id, 'GET')
}
// 知识库列表
export function getCorpusSuiteName(data) {
  return request('/gene/api/corpus-suite-names', 'GET', data)
}
// 获取健康档案详情
export function getHealthRecordDetail(id) {
  return request('/uaa/api/user/health-records/' + id, 'GET')
}
// 已邀请用户列表
export function pageInvitationUsers(data) {
  return request('/uaa/api/mall-user/page-invitation-users', 'POST', data)
}
// 获取城市列表
export function getAllCity() {
  return request('/messages/api/admin-divisions/city', 'GET')
}
// 导出实验室订单
export function exportLabOrders(data) {
  return exportBinary(`lab/api/gene/order/export-excel`, 'POST', data)
}
/**
 * oss直传获取签名(除lab服务外)
 * @param {*} data
 */
export function ossUploadBigFileNotLab(data) {
  return request('lab/api/upload-policy', 'POST', data)
}
/**
 * 获取第三方代理商类型
 */
export function getVendorType() {
  return request('uaa/api/enum/vendor-types', 'GET')
}
/**
 * 修改密码
 */
export function changePassword(data) {
  return request('uaa/api/account/change-password', 'POST', data)
}
// 获取税务项目管理列表
export function getTaxProjctList(data) {
  return request('/pay/api/tax-project-manages', 'GET', data)
}
// 新建税务项目
export function creatTaxProject(data) {
  return request('/pay/api/tax-project-manages', 'POST', data)
}
// 获取税务项目详情
export function getTaxPrejectDetail(id) {
  return request('/pay/api/tax-project-manages/' + id, 'GET')
}
// 编辑税务项目
export function editTaxProject(data) {
  return request('/pay/api/tax-project-manages', 'PUT', data)
}
// 删除税务项目
export function deleteTaxProject(id) {
  return request('/pay/api/tax-project-manages/' + id, 'DELETE')
}
export function getOrganizations() {
  let data = {
    page: 0,
    size: 99999
  }
  return request('/uaa/api/client-organizations', 'GET', data)
}
// 修改实验室订单
export function editLabOrder(data) {
  return request('/lab/api/orders/edit', 'POST', data)
}
// 批量创建物料
export function createdMaterialsLot(data) {
  return request('/lab/api/materials/import', 'POST', data)
}
// 业务来源通用枚举
export function businessSource() {
  return request('/uaa/api/enum/business-sources', 'GET')
}
// 使用example对象为当前用户查询存储项列表
export function exportHistoryList(data) {
  return request('/mallsales/api/user/oss/items/by-example', 'POST', data)
}
// 使用example对象为当前用户查询存储项列表(实验室订单)
export function labExportHistoryList(data) {
  return request('/lab/api/user/oss/items/by-example', 'POST', data)
}
// 从导出历史列表中下载
export function exportHistoryDownload(id) {
  return request('/mallsales/api/user/oss/items/download/' + id, 'GET')
}
// 批量上传报告
export function uploadReport(data) {
  return request('/lab/api/workflow/upload-report', 'POST', data)
}
// 批量下载报告
export function downloadReport(data) {
  return request('/lab/api/gene/order/export-pdf', 'POST', data)
}
// 报告审核上传真正的报告
export function uploadReports(data) {
  return request('/lab/api/orders/update-reports', 'POST', data)
}
// 获取代理商地区
export function getBusinessArea() {
  return request('/lab/api/enumeration/BUSINESS_ORIGIN_AREA', 'GET')
}
// 获取套餐的接口
export function getPackages() {
  return request('/lab/api/detection-package-entities', 'GET')
}
// 获取cps缴费记录分公司列表
export function findBranchCompany() {
  return request('/mallsales/api/mall/order/bill/find-branch-company', 'GET')
}
// 判断用户是否有筛选分公司的权限
export function isCompanyValide() {
  return request('/mallsales/api/mall/order/bill/branch/is-visible', 'GET')
}

// 获取意见反馈列表
export function getFeedbackList(data) {
  return request('/mall/api/feedbacks/search', 'POST', data)
}
// 创建代理商合同
export function getAgentcontractsCreate(data) {
  return request('/lab/api/agent-contracts/create', 'POST', data)
}
// 编辑代理商合同
export function getAgentcontractsEdit(data) {
  return request('/lab/api/agent-contracts/edit', 'POST', data)
}

// 创建代理商产品
export function getAgentproductCreate(data) {
  return request('/lab/api/agent-products/create', 'POST', data)
}
// 编辑代理商产品
export function getAgentproductEdit(data) {
  return request('/lab/api/agent-product-contracts/edit', 'POST', data)
}
// 编辑代理商产品(国科大专用)
export function agentProductEdit(data) {
  return request('/lab/api/agent-products/edit', 'POST', data)
}
// 删除代理商产品（国科大专用）
export function deleteAgentProduct(id) {
  return request(`/lab/api/agent-product/delete/${id}`, 'GET')
}
// 获取代理商产品详情（国科大专用）
export function getAgentProduct(id) {
  return request(`/lab/api/agent-products/${id}`, 'GET')
}
// 代理商商品查询
export function getAgentproductQuery(data) {
  return request('/lab/api/agent-product-contracts/query', 'POST', data)
}
// 获取客户列表
export function getRoleList(data) {
  return request('/uaa/api/organizations/with-role', 'POST', data)
}
// 获取合同列表
export function getContractList(data) {
  return request('/lab/api/user/agent-contracts/query', 'POST', data)
}
// 获取代理商合同商品（包括合同信息）
export function getProductList(data) {
  return request('/lab/api/user/agent-product-contracts/query', 'POST', data)
}
// 获取合同商品（商品信息）
export function getUserProduct(data) {
  return request('/lab/api/agent-products/query', 'POST', data)
}
// 获取合同产品详情
export function getProductDetail(data) {
  return request('/lab/api/user/agent-product-contracts/detail/' + data, 'GET')
}
// 获取合同详情
export function getContractDetail(data) {
  return request('/lab/api/user/agent-contracts/detail/' + data, 'GET')
}
// 删除客户合同
export function deleteContract(id) {
  return request('/lab/api/agent-contracts/delete/' + id, 'GET')
}
// 删除客户商品
export function deleteProduct(id) {
  return request('/lab/api/agent-product-contracts/delete/' + id, 'GET')
}
// 超期订单统计
export function getCount(data) {
  return request('/lab/api/user/agent-product-contracts/will-expire/count ', 'GET', data)
}
// 是否本地部署
export function LocalIsEnabled() {
  return request('/lab/api/user/agent-contracts/is-enabled', 'GET')
}
// 获取签章列表
export function getSignatureList(data) {
  return request('/gene/api/signature-managements', 'GET', data)
}
// 新建签章
export function createSignatureList(data) {
  return request('/gene/api/signature-managements', 'POST', data)
}
// 删除签章
export function deleteSignature(data) {
  return request('/gene/api/signature-managements/' + data, 'DELETE', data)
}
// 获取签章详情
export function getSignatureDetail(data) {
  return request('/gene/api/signature-managements/' + data, 'GET')
}
// 编辑签章
export function updateSignatureDetail(data) {
  return request('/gene/api/signature-managements', 'PUT', data)
}
// 实验室订单导出记录删除
export function getTenantInfo(url) {
  return request('/api/public/tenant/information?url=' + url, 'GET')
}
// 本地环境 不选择组织 指定创建用户
export function createOrganizationLocal(data) {
  return request('uaa/api/organization-user-admin/current-organization', 'POST', data)
}
/**
 * 样本提取预览接口
 * @param {*} data
 */
export function orderBatchReview(data) {
  return request('/lab/api/workflow/order-batch-review', 'POST', data)
}
export function boardBatchReview(data) {
  return request('/lab/api/batch-sample-plates-review', 'POST', data)
}
// 获取实验室产品线
export function getLabProductLine() {
  return request('/lab/api/gene/product/type/by-example', 'POST', {})
}

// 获取历史芯片列表
export function getHistoryChipList(data) {
  return request('/lab/api/chip-materials/list', 'POST', data)
}
export function getIndexName(data) {
  return request('/lab/api/chip-models/by-example', 'POST', data)
}
export function getHistoryChipListSearch(data) {
  return request('/lab/api/chip-materials/search', 'POST', data)
}
export function getHistoryChipListDetail(id) {
  return request(`/lab/api/chip-materials/details/${id}`, 'GET')
}
// 获取历史芯片详情
export function getHistoryChipDeatil(data) {
  return request(`/lab/api/chip-materials/${data}`, 'GET')
}
// 获取布局列表 带搜索
export function getChipDescriptionListSearch(data) {
  return request('/lab/api/chip-models/search', 'POST', data)
}
// 获取布局列表
export function getChipDescriptionList(data) {
  return request('/lab/api/chip-models', 'GET', data)
}
// 获取物料列表
export function getMaterailList(data) {
  return request('/lab/api/materials/by-example', 'POST', data)
}
// 新建物料
export function createMaterail(data) {
  return request('/lab/api/materials', 'POST', data)
}
// 更新物料
export function updateMaterail(data) {
  return request('/lab/api/materials', 'PUT', data)
}
// 获取物料使用单位
export function getMaterailUnits(data) {
  return request('/lab/api/material-units', 'GET', data)
}
// 获取物料品牌
export function getMaterailBrands(data) {
  return request('/lab/api/material-brands', 'GET', data)
}
// 获取包装单位
export function getMaterailPackageUnits(data) {
  return request('/lab/api/material-packageUnits', 'GET', data)
}
// 获取物料详情
export function getMaterailDeatil(data) {
  return request(`/lab/api/materials/${data}`, 'GET')
}
// 删除物料信息
export function deleteMaterail(data) {
  return request(`/lab/api/materials/${data}`, 'DELETE')
}
// 新建布局
export function createChipDescription(data) {
  return request('/lab/api/chip-models', 'POST', data)
}
// 编辑布局
export function updateChipDescription(data) {
  return request('/lab/api/chip-models', 'PUT', data)
}
// 布局详情
export function getChipDescriptionDetail(id) {
  return request(`/lab/api/chip-models/${id}`, 'GET')
}
// 获取代理商列表
export function getProviderList(data) {
  return request(`/lab/api/material-providers`, 'GET', data)
}
// 新建入库信息
export function createStockIn(data) {
  return request('/lab/api/stock-ins', 'POST', data)
}
// 编辑入库信息
export function updateStockIn(data) {
  return request('/lab/api/stock-ins', 'PUT', data)
}
// 获取入库信息详情
export function getStockInDetail(data) {
  return request(`lab/api/stock-ins/${data}`, 'GET')
}
// 获取入库信息列表
export function getStockInList(data) {
  // return request('/lab/api/stock-ins', 'GET', data)
  return request('/lab/api/stock-ins/by-example', 'POST', data)
}
// 删除入库信息
export function deleteStockIn(data) {
  return request(`/lab/api/stock-ins/${data}`, 'DELETE')
}
// 导出入库信息
export function ExportStockIn(data) {
  return request(`/lab/api/stock-ins/export-excel`, 'POST', data)
}
// 导出出库信息
export function ExportStockOut(data) {
  return request(`/lab/api/stock-outs/export-excel`, 'POST', data)
}
// 获取出库信息
export function getStockOutList(data) {
  // return request('/lab/api/stock-outs', 'GET', data)
  return request('/lab/api/stock-outs/by-example', 'POST', data)
}
// 创建出库记录
export function createStockOut(data) {
  return request('/lab/api/stock-outs', 'POST', data)
}
// 编辑出库记录
export function updateStockOut(data) {
  return request('/lab/api/stock-outs', 'PUT', data)
}
// 删除出库
export function deleteStockOut(data) {
  return request(`/lab/api/stock-outs/${data}`, 'DELETE')
}
// 获取出库详情
export function getStockOutDetail(data) {
  return request(`/lab/api/stock-outs/${data}`, 'GET')
}
// 删除实验室订单
export function deleteLabOrder(id) {
  let data = {
    orderId: id
  }
  return request(`/lab/api/future-order-action-tasks/order/delete`, 'GET', data)
}

// 库存 入库列表
export function stockInInventory(data) {
  return request('/lab/api/stock-ins/inventory', 'POST', data)
}
// 库存 出库列表
export function stockOutInventory(data) {
  return request('/lab/api/stock-outs/inventory', 'POST', data)
}

// 导出生产任务单
export function ExportProductionTasks(data) {
  return request('/lab/api/production-tasks/export-excel', 'POST', data)
}
// 导出库存
export function ExportQuantifier(data) {
  return request('/lab/api/materials/inventory/export-excel', 'POST', data)
}

// 新建生产任务单
export function createProductionTasks(data) {
  return request('/lab/api/production-tasks', 'POST', data)
}
// 编辑生产任务单
export function updateProductionTasks(data) {
  return request('/lab/api/production-tasks', 'PUT', data)
}
// 删除生产任务单
export function deleteProductionTasks(id) {
  return request(`/lab/api/production-tasks/${id}`, 'DELETE')
}
// 获取实验人员列表
export function getLabTesterList(data) {
  return request(`/uaa/api/role-informations`, 'GET', data)
}
export function createChipMaterial(data) {
  return request(`/lab/api/chip-materials`, 'POST', data)
}
// 获取芯片的排版区域
export function getAssignedData(chipMaterialId) {
  return request(`/lab/api/chip-slot-assigns/assigned-area/${chipMaterialId}`, 'GET')
}
// 获取生产任务单所需物料
export function getTaskMaterials(id) {
  return request(`/lab/api/production-tasks/order-materials/${id}`, 'GET')
}
// 获取指定芯片的排版历史
export function getChipRecords(data) {
  return request(`/lab/api/chip-slot-assign-records/by-example`, 'POST', data)
}
// 芯片 释放
export function toReleasedChip(id) {
  return request(`/lab/api/chip-slot-assign-records/release/${id}`, 'POST', id)
}
// 批次列表
export function batchList(data) {
  return request(`/lab/api/gene/order/batch/by-example`, 'POST', data)
}
// 历史芯片列表 下载
export function downloadExcel(id) {
  return request(`lab/api/chip-slot-assigns/export-excel-by-chip/${id}`, 'GET', {}, { responseType: 'blob' })
}
// 芯片排版历史 下载
export function downloadChipHistoryExcel(id) {
  return request(`lab/api/chip-slot-assigns/export-excel/${id}`, 'GET', {}, { responseType: 'blob' })
}
// 下载
export function downloadTestExcel() {
  return request(`lab/api/public/excel-test`, 'GET', {}, { responseType: 'blob' })
}
// 编辑角色
export function rolesEdit(data) {
  return request('/uaa/api/roles', 'PUT', data)
}
// 新建角色
export function createdRoles(data) {
  return request('/uaa/api/roles', 'POST', data)
}

// 剩余可选芯片
export function getChipHasSlots(data) {
  return request('/lab/api/chip-materials-has-slots', 'POST', data)
}
// 历史芯片查询更换接口 /chip-materials-has-slots/by-plate
export function getChipHasSlotsPlate(data) {
  return request('/lab/api/chip-materials-has-slots/by-plate', 'POST', data)
}
// 获取样本提取质检标准
export function getStandard(inspectionStandard) {
  return request(`/lab/api/gene/product/inspectionStandard/${inspectionStandard}`, 'GET')
}
// 获取扩增质检标准
export function getAmplificationStandard(inspectionStandard) {
  return request(`/lab/api/gene/product/inspectionStandard/amplification/${inspectionStandard}`, 'GET')
}
// 节假日查询
export function getHolidays(data) {
  return request('/lab/api/holiday/search', 'POST', data)
}
// 节假日创建
export function createHoliday(data) {
  return request('/lab/api/holiday/create', 'POST', data)
}
// 节假日修改
export function editHoliday(data) {
  return request('/lab/api/holiday/edit', 'POST', data)
}
// 单个节假日删除
export function deleteHoliday(id) {
  return request(`/lab/api/holiday/delete/${id}`, 'GET')
}
// 批量节假日删除
export function deleteHolidays(ids) {
  return request(`/lab/api/holiday/delete-by-ids`, 'POST', ids)
}
// 批量节假日获取
export function getHoliday(id) {
  return request(`/lab/api/holiday/by-id/${id}`, 'GET')
}
// 批量节假日导入
export function importHoliday(data) {
  return request(`/lab/api/holiday/import`, 'POST', data)
}
// 终止合同
export function terminateContracts(id) {
  return request(`/lab/api/agent-contracts/stop/${id} `, 'GET')
}
// 终止合同商品
export function terminateProduct(id) {
  return request(`/lab/api/agent-product-contracts/stop/${id}`, 'GET')
}
export function downloadRawData(data) {
  return request(`/lab/api/gene/order/export-raw-data`, 'POST', data)
}
// 导出历史芯片
export function exportHistoryChip(data) {
  return request(`/lab/api/chip-slot-assigns/export-excel-batch`, 'POST', data)
}
// 创建多张芯片芯片
export function createMultipleChip(data) {
  return request(`/lab/api/chip-materials/multi`, 'POST', data)
}
// 批次订单详情导出
export function exportConciseExcel(data) {
  return request(`lab/api/gene/order/concise-excel`, 'POST', data)
}
/**
 * 入库
 * @param {*} data
 */
export function inbound(data) {
  return request('/lab/api/inventories/warehousing', 'POST', data)
}
/**
 * 获取盒子类型列表
 */
export function getBoxType() {
  return request('/lab/api/enumeration/BOX_TYPE', 'GET')
}
/**
 * 根据样本ID找到agentId
 * @param {*} sampleIds
 */
export function findAgentIdBySampleId(sampleId) {
  return request(`/lab/api/inventories/find/${sampleId}`, 'GET')
}
/**
 * 生产记录
 */
export function getBoxInventories(data) {
  return request('lab/api/inventories/by-example', 'POST', data)
}
/**
 * 搜索生产记录
 */
export function searchBoxInventories(data) {
  return request('lab/api/inventories/query', 'GET', data)
}
/**
 * 出库扫码获取详细信息
 * @param {*} data
 */
export function findDetailBySampleId(id) {
  let data = {
    example: {
      sampleId: id
    },
    pageable: {
      page: 0,
      size: 9999
    }
  }
  return request('/lab/api/inventories/by-example', 'POST', data)
}
/**
 * 出库
 * @param {*} data
 */
export function outbound(data) {
  return request('/lab/api/inventories/output', 'POST', data)
}
/**
 * 根据代理商ID获取对应的产品
 * @param {*} clientId
 */
export function getProductByClientId(clientId) {
  let data = {
    'organizationId': clientId,
    'pageableParam': {
      'page': 0,
      'size': 99999
    }
  }
  return request('/lab/api/agent-products/query', 'POST', data)
}
/**
 * 获取盒子详情
 */
export function getBoxDetail(id) {
  return request(`lab/api/inventories/${id}`, 'GET')
}
/**
 * 编辑盒子
 */
export function updateBox(data) {
  return request(`lab/api/inventories`, 'PUT', data)
}
// 获取报告模板列表
export function getTemplateList(data) {
  return request(`gene/api/package-templates/${data.agentId}/${data.packageId}`, 'GET')
    // return request(`gene/api/package-templates/herdel/123456789`, 'GET')
}
// 储存实验室流程中异常原因
export function addAbnormalReason(data) {
  return request(`lab/api/enumeration/add`, 'POST', data)
}
// 获取实验室流程中异常原因
export function getAbnormalReason(type) {
  return request(`lab/api/enumeration/${type}`, 'GET')
}
// 动态获取普通订单workflow
export function getOrderWorkFlow() {
  return request(`lab/api/orders/workflow`, 'GET')
}
// 动态获取重采订单workflow
export function getWorkFlowRecollect() {
  return request(`lab/api/orders/workflow-recollect`, 'GET')
}
// =============样本板 BEGIN==============

// 样本板转板目的筛选条件
export function getActionReason(data) {
  return request(`lab/api/sample-plates/action-reason`, 'GET', data)
}
// 样本板列表
export function getSampleBoardList(data) {
  return request(`lab/api/sample-plates/by-example`, 'POST', data)
}
// 单个样本板详情
export function getSampleBoardDetail(id) {
  return request(`lab/api/sample-plates/${id}`, 'GET')
}
// 样本板整版样本状态更新
export function getSampleBoardStatusUpdate(data) {
  return request(`lab/api/sample-plates-status-update`, 'POST', data)
}
// 样本板排版表下载
export function getSamplePlatesOrders(data) {
  return request(`/lab/api/sample-plates/orders`, 'POST', data)
}
// 样本提取质检报告预览
export function getSamplePlatesReview(data) {
  return request(`lab/api/sample-plates-review`, 'POST', data)
}
// 样本板详情照片记录
export function getSamplePlatesUpload(data) {
  return request(`/lab/api/sample-plates/upload-file`, 'POST', data)
}
// 样本板列表导出记录
export function getSamplePlatesExcel(data) {
  return request(`/lab/api/sample-plates/export-excel`, 'POST', data)
}
// 选择已有样本板
export function sampleBoardCanUseList(data) {
  return request(`lab/api/sample-plates/can-use`, 'POST', data)
}
// 样本板批量操作上传图片
export function uploadBatchImages(data) {
  return request(`lab/api/upload-batch-images`, 'POST', data)
}
// =============样本板 END==============
// 批量导入订单轮询接口
export function getSamplesjobRecord(jobRecordId) {
  return request(`lab/api/job-record/${jobRecordId}`, 'GET')
}
// 批量导入订单轮询接口(多个文件)
export function getSamplesjobRecords(jobRecordIds) {
  return request(`lab/api/job-record/all-ids`, 'POST',jobRecordIds)
}
export function getSamplesjobRecordAll(data) {
  return request(`lab/api/job-record/all`, 'POST', data)
}
export function getSamplesjobRecordError(id) {
  return request(`lab/api/job-record/pending/${id}`, 'GET')
}
export function getSamplesjobRecordPending(data) {
  return request(`lab/api/job-record/pending`, 'POST', data)
}
// 首页统计接口-订单组成
export function getOrderCountStatistical(data) {
  return request(`lab/api/order-count/order-total-group`, 'POST', data)
}
// 首页统计接口-样本量统计
export function getTrendStatistics(data) {
  return request(`lab/api/order-count/trend-statistics`, 'POST', data)
}
// 首页统计接口-实验室周转能力
export function getCycleTime(data) {
  return request(`lab/api/order-count/cycle_time`, 'POST', data)
}
// 实验室人员
export function getOperatorList(data) {
  return request(`lab/api/order-count/operator_list`, 'POST', data)
}
// 订单总数/完成/接收
export function getOrderCountSummary(data) {
  return request(`lab/api/order-count/summary`, 'POST', data)
}
// 超期/已完成超期/超期总数
export function getOrderCountExpiredOrder(data) {
  return request(`lab/api/order-count/expired-order`, 'POST', data)
}
// 异常/已处理异常/异常总数
export function getOrderCountErrorOrder(data) {
  return request(`lab/api/order-count/error-order`, 'POST', data)
}
// 实验室产品--按客户统计
export function getLabProductByClients(data) {
  return request(`lab/api/order-count/lab-product-by-clients`, 'POST', data)
}
// 关键节点
export function getOrderStatusDetail(data) {
  return request(`lab/api/order-count/order-status-details`, 'POST', data)
}
export function getOrderStatusError(data) {
  return request(`lab/api/order-count/order-status-error`, 'POST', data)
}
export function getWatingOperateOrder(data) {
  return request(`lab/api/order-count/waiting-operate-order`, 'POST', data)
}
// 批量样本版交互样式
export function getSamplePlatesProcess(data) {
  return request(`lab/api/sample-plates/is-process`, 'POST', data)
}
// 建库试剂盒
export function getReagentKitList(data) {
  return request('/lab/api/reagent-kit/by-example', 'POST', data)
}

export function getReagentKitSave(data) {
  return request('/lab/api/reagent-kit/save', 'POST', data)
}
export function getReagentKitDelete(id) {
  return request(`/lab/api/reagent-kit/delete/${id}`, 'GET')
}
export function getReagentKitDetail(id) {
  return request(`/lab/api/reagent-kit/${id}`, 'GET')
}
export function getReagentKitSEQUENCER() {
  return request(`lab/api/enumeration/SEQUENCER`, 'GET')
}
// Index接头类型
export function getIndexKitList(data) {
  return request('/lab/api/index-adapter/by-example', 'POST', data)
}
export function getIndexKitSave(data) {
  return request('/lab/api/index-adapter/save', 'POST', data)
}
export function getIndexKitDelete(id) {
  return request(`/lab/api/index-adapter/delete/${id}`, 'GET')
}
export function getIndexKitDetail(id) {
  return request(`/lab/api/index-adapter/${id}`, 'GET')
}
// 样本类型
export function getSAMPLETYPE() {
  return request(`/lab/api/enumeration/SAMPLE_TYPE`, 'GET')
}
// 样本类型管理
export function getSampleTypeList(data) {
  return request('/lab/api/enumeration/query', 'POST', data)
}
// add
export function getSampleTypeSave(data) {
  return request('/lab/api/enumeration/add', 'POST', data)
}
// edit /lab/api/enumeration
export function getSampleTypeEdit(data) {
  return request('/lab/api/enumeration', 'POST', data)
}
// delete
export function getSampleTypeDelete(id) {
  return request(`/lab/api/enumeration/${id}`, 'DELETE')
}
export function getSampleTypeDetail(id) {
  return request(`/lab/api/enumeration/find-one/${id}`, 'GET')
}
// 默认布局/api/chip-models/default
export function getDefaultLayout(data) {
  return request(`/lab/api/chip-models/default`, 'GET', data)
}

// LH------------------------------------------------------------
// 实验室产品列表
export function getLabProductList(data) {
  return request('/lab/api/lab-exam-items/by-example', 'POST', data)
}
// 实验室产品--新建
export function labProductAdd(form) {
  return request('/lab/api/lab-exam-items', 'POST', form)
}
// 实验室产品更新
export function updateLabProduct(form) {
  return request('/lab/api/lab-exam-items', 'PUT', form)
}
/**
 * 实验室产品 - 获取详情
 * @param {*} id
 */
export function getLabProduct(id) {
  return request(`/lab/api/lab-exam-items/${id}`)
}
// 实验室产品删除
export function deleteLabProduct(id) {
  return request(`/lab/api/lab-exam-items/${id}`, 'DELETE')
}
// 获取客户组织列表
export function getOrganizationsList(data) {
  return request('/uaa/api/organizations/by-example', 'POST', data)
}
// 创建客户
export function createOrganization(data) {
  return request('/uaa/api/organizations', 'POST', data)
}
// 修改客户
export function updateVendor(data) {
  return request('/uaa/api/organizations', 'PUT', data)
}
// 获取指定客户
export function getVendor(id) {
  return request(`/uaa/api/organizations/${id}`, 'GET')
}
// 删除指定客户
export function deleteVendor(id) {
  return request(`/uaa/api/organizations/${id}`, 'DELETE')
}
// 获取委托单列表
export function getBillList(data) {
  return request('/lab/api/bills/by-example', 'POST', data)
}
// 批量创建委托单
export function createBatchBill(data) {
  return request('/lab/api/workflow/bill/import/by-workflow', 'POST', data)
}
// 批量创建样本
export function createBatchOrder(data) {
  return request('/lab/api/workflow/order/import/by-workflow', 'POST', data)
}
// 创建委托单
export function createBill(data) {
  return request('/lab/api/bills/with-workflow', 'POST', data)
}
// 修改委托单
export function updateBill(data) {
  return request('/lab/api/bills/edit', 'POST', data)
}
// 获取指定委托单
export function getBill(id) {
  return request(`/lab/api/bills/detail/${id}`, 'GET')
}
// 删除指定委托单
export function deleteBill(id) {
  return request(`/lab/api/bills/${id}`, 'DELETE')
}
// 删除指定委托单
export function closeBill(id) {
  return request(`/lab/api/bills/close/${id}`, 'GET')
}
// 获取检测方法列表
export function getMethodList() {
  return request('/lab/api/exam-method/items', 'GET')
}
// 结算/开票和邮寄
export function billOtherUpdate(data) {
  return request('/lab/api/bills/update', 'POST', data)
}
// 获取生产任务单列表
export function getProductionTasksList(data) {
  return request('/lab/api/production-tasks/by-example', 'POST', data)
}
// 获取样品列表
export function getSampleList(data) {
  return request('/lab/api/orders/by-example', 'POST', data)
}
// 获取当前的主要组织
export function getPrimaryOrganization() {
  return request('/uaa/api/organizations/primary', 'GET')
}
// 基因实验室订单（包括订单详情，订单状态详情，和订单小状态）
export function getLabOrderDetail(id) {
  return request(`/lab/api/order/details/${id}`, 'GET')
}
// 获取所有检测依据
export function getAllExamBasis() {
  return request('/lab/api/lab-exam-items/all/examBasis', 'GET')
}
// 指定的组织创建用户
export function createdOrgCustomer(data) {
  return request('/uaa/api/organization-user-admin', 'POST', data)
}
// 系统用户列表
export function systemCustomerList(data) {
  return request('/uaa/api/organization-user-admin/roles', 'POST', data)
}
// 获取角色列表
export function rolesList(data) {
  return request('/uaa/api/roles', 'GET', data)
}
// 删除系统用户
export function deleteOrganizationUser(data) {
  return request('/uaa/api/organization-user-admin/roles?userLogin=' + data.userLogin, 'DELETE')
}
// 获取系统用户详情
export function organizationUserInformation(data) {
  return request('/uaa/api/organization-user-admin/information', 'GET', data)
}
// 更新系统用户
export function updateOrganizationUser(data) {
  return request('/uaa/api/organization-user-admin/update', 'POST', data)
}
// 删除角色
export function rolesDelete(id) {
  return request('/uaa/api/roles/' + id, 'DELETE')
}
// 角色权限列表
export function rolesStatistics(data) {
  return request('/uaa/api/roles/statistics', 'GET', data)
}
// 获取权限列表
export function getPermissionsList(data) {
  return request('/uaa/api/permissions', 'GET', data)
}
// 获取角色详情
export function rolesDetail(name) {
  return request('/uaa/api/roles/' + name, 'GET')
}
// 批量创建实验室订单
export function creatLabOrder(data) {
  return request('/lab/api/orders/with-workflow', 'POST', data)
}
// 关闭实验室订单
export function closeLabOrder(orderId) {
  return request(`/lab/api/orders/close/${orderId}`, 'GET')
}
// 委托单导出
export function billsExportExcel(data) {
  return request(`/lab/api/bills/export-excel`, 'POST', data)
}
// 生产任务导出
export function prodTasksExportExcel(data) {
  return request(`/lab/api/production-tasks/export-excel`, 'POST', data)
}
// 样本导出
export function getOrderExportExcel(data) {
  return request(`/lab/api/orders/export-excel`, 'POST', data)
}
// 生产任务导出
export function getProductionTaskExportExcel(data) {
  return request(`/lab/api/production-tasks/export-excel`, 'POST', data)
}
export function getProductionTaskDownloadExcel(data) {
  return request(`/lab/api/task-orders/download`, 'POST', data)
}
// 委托单下载
export function billsExportPdf(data) {
  return request(`/lab/api/bills/export-pdf`, 'POST', data)
}
//报告下载
export function billsExportReport(data) {
  return request(`/lab/api/bills/export-word`, 'POST', data)
}
// 委托单状态更新
export function updateBillStatus(data) {
  return request(`/lab/api/workflow/bill-status-update`, 'POST', data)
}
// 解除样品和委托单的关联关系
export function removeOrders(data) {
  return request(`/lab/api/bills/removeOrders`, 'DELETE', data)
}
// 任务分派预选保存
export function assginPre(data) {
  return request(`/lab/api/bill/assgin-pre/save`, 'POST', data)
}
// 获取委托单分派预选样品列表
export function getAssginPre(data) {
  return request(`/lab/api/bill/assgin-pre/by-example`, 'POST', data)
}
// 委托单分派预选添加样品
export function addAssginPre(data) {
  return request(`/lab/api/bill/assgin-pre/add`, 'POST', data)
}
// 委托单分派预选移除样品
export function deleteAssginPre(data) {
  return request(`/lab/api/bill/assgin-pre/delete`, 'POST', data)
}
// 获取委托单中样品总数以及委托单相关信息（用于任务分派页面）
export function getOrderCountByBill(billId) {
  return request(`/lab/api/bill/assgin-pre/${billId}`, 'GET')
}
// 获取生产任务单详情
export function getProductionTasksDetail(id) {
  return request(`/lab/api/production-tasks/details/${id}`, 'GET')
}
/**
 * 基因实验室订单状态更新
 * @param {*} data
 */
export function geneOrderStatusUpdate(data) {
  return request('/lab/api/workflow/order-batch-status-update', 'POST', data)
}
// 任务改派
export function taskReassgin(data) {
  return request(`/lab/api/production-tasks/reassignment`, 'POST', data)
}
// 任务延期
export function taskDelay(data) {
  return request(`/lab/api/production-tasks/delay`, 'POST', data)
}
// 添加已有样品到委托单中
export function addExistOrderToBill(data) {
  return request(`/lab/api/bills/add/existOrders`, 'POST', data)
}
// 添加新的样品到委托单中
export function addNewOrdersToBill(data) {
  return request(`/lab/api/bills/add/newOrders`, 'POST', data)
}
// 任务单移除样品
export function removeOrdersFromTask(data) {
  return request(`/lab/api/production-tasks/unbind`, 'POST', data)
}
// 任务单新增样品
export function addOrdersToTask(data) {
  return request(`/lab/api/production-tasks/bind`, 'POST', data)
}
// 委托单待办
export function billPendingTasksSubmit(data) {
  return request(`/lab/api/future-bill-action-tasks/submit`, 'POST', data)
}
// 获取任务单中样品总数以及任务单相关信息（用于任务分派页面）
export function getOrderCountByTask(taskId) {
  return request(`/lab/api/bill/assgin-pre/task/${taskId}`, 'GET')
}
// 获取任务单中样品总数以及任务单相关信息（用于任务分派页面）
export function distributeOrderFromTask(data) {
  return request(`/lab/api/production-tasks/assgin/orders`, 'POST', data)
}
// 编辑任务单
export function updateTask(data) {
  return request(`/lab/api/production-tasks`, 'PUT', data)
}
// 关闭任务单
export function closeTask(taskId) {
  return request(`/lab/api/production-tasks/close/${taskId}`, 'GET')
}
// 删除任务单
export function deleteTask(id) {
  return request(`/lab/api/production-tasks/${id}`, 'DELETE')
}

// 获取委托单中待重采的样品
export function getRecollectOrders(data) {
  return request(`/lab/api/orders/future`, 'POST', data)
}
// 获取委托单中待重采的样品
export function recollectOrdersByBill(data) {
  return request(`/lab/api/orders/recollect/with-workflow`, 'POST', data)
}
// 导入历史（委托单和样本）
export function importHistoryOfBill(data) {
  return request(`/lab/api/job-record/all`, 'POST', data)
}
export function DeleteLabOrderHistory(id) {
  return request('/lab/api/job-record/delete/' + id, 'DELETE')
}
//删除下载和导出历史
export function deleteDownloadHistory(id) {
  return request(`/lab/api/user/oss/items/delete/${id}`, 'GET')
}
// 批量操作委托单状态更新
export function updateBatchBillStatus(data) {
  return request(`/lab/api/workflow/batch/bill-status-update`, 'POST', data)
}
// 批量操作任务单状态更新
export function updateBatchTaskStatus(data) {
  return request(`/lab/api/production-tasks-batch-update`, 'POST', data)
}
// 委托单批量操作：获取委托单列表
export function getBatchBillList(data) {
  return request('/lab/api/batch/bills/by-example', 'POST', data)
}
// 委托单催缴
export function callNotice(data) {
  return request('/lab/api/bills/call-notice', 'POST', data)
}
// 获取科室
export function getOffices() {
  return request('/uaa/api/offices', 'GET')
}
//撤销开票或结算
export function cancelBills(data) {
  return request('/lab/api/bills/cancel', 'POST', data)
}
//核磁表格下载
export function getMrTableDownload(data) {
  return request('/lab/api/bills/mr-export-excel', 'POST', data)
}
//出入库表格下载
export function getInOutTableDownload(data) {
  return request('/lab/api/bills/in-out-export', 'POST', data)
}
//复制委托单（委托单快捷创建方式）
export function copyBills(id) {
  return request(`/lab/api/bills/with-workflow/copy?id=${id}`, 'POST')
}
//委托单批量删除
export function deleteBills(ids) {
  return request('/lab/api/bills/delete', 'POST', ids)
}